import React from 'react';
import Slider from "react-slick";

function Testimonial({data}) {
    
    const settings1 = {
        infinite: true,
        speed: 1500,
        arrows: true,
        slidesToShow: 2,
        autoplay: true,
        dots: true,
        autoplaySpeed: 5000,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    adaptiveHeight: false,
                },
            },
        ],
    };
  return (
    <>
        <section className='testimonial-section'>
            <div className='container'>
                <div className='top-head'>
                    <h2 className='ttl1'>What Employees Are Saying About Us!</h2>
                </div>
                <div className='slider-sec'>
                    <Slider {...settings1}>
                    {data.CareerData.map((response, index) => (
                        <div className="slide-card">
                            
                            <div className='testimonial-details'>
                                <div className='testimonial-header'>
                                    <div className='testimonial-ttl'>
                                        <img src={response.image} className="img-fluid" width={43} height={43}/>
                                        <div>
                                            <h6>{response.name}</h6>
                                            <p>{response.designation}</p>
                                        </div>
                                    </div>
                                    <div className='review'>
                                    </div>
                                </div>
                                <div className='testimonial-caption'>
                                    <p className='caption-heading'>{response.heading}</p>
                                    <p>{response.para}</p>
                                </div>
                            </div>
                           
                        </div>
                         ))}
                        
                    </Slider>
                </div>
            </div>
        </section>
    </>
  )
}

export default Testimonial